import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import {
    RealTimeInventoryModel,
    RealTimePricingModel,
} from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";
import CustomProductInfoListStatusState from "@MasterBluePrint/Store/Components/CustomProductInfoList/CustomProductInfoListStatusState";

const initialState: CustomProductInfoListStatusState = {
    productInfoListStatusById: {},
};

const reducer = {
    "Components/CustomProductInfoLists/CompleteLoadProductInfoList": (
        draft: Draft<CustomProductInfoListStatusState>,
        action: {
            id: string;
            parameter?: GetProductCollectionApiV2Parameter;
            productInfos: ProductInfo[];
            errorMessage?: string;
        },
    ) => {
        draft.productInfoListStatusById[action.id] = { 
            isRealTimePricingLoaded: false,
            isRealTimeInventoryLoaded: false
        };
    },
    "Components/CustomProductInfoLists/CompleteLoadRealTimePricing": (
        draft: Draft<CustomProductInfoListStatusState>,
        action: { realTimePricing: RealTimePricingModel; id: string, isRealTimePricingLoaded: boolean },
    ) => {
        const productInfoList = draft.productInfoListStatusById[action.id];
        if (!productInfoList) {
            throw new Error(`There was no productInfoList found for the id ${action.id}`);
        }

        productInfoList.isRealTimePricingLoaded = action.isRealTimePricingLoaded;

    },
    "Components/CustomProductInfoLists/FailedLoadRealTimePricing": (
        draft: Draft<CustomProductInfoListStatusState>,
        action: { id: string, isRealTimePricingLoaded: boolean },
    ) => {
        const productInfoList = draft.productInfoListStatusById[action.id];
        if (!productInfoList) {
            throw new Error(`There was no productInfoList found for the id ${action.id}`);
        }

        productInfoList.isRealTimePricingLoaded = action.isRealTimePricingLoaded;
    },
    "Components/CustomProductInfoLists/CompleteLoadRealTimeInventory": (
        draft: Draft<CustomProductInfoListStatusState>,
        action: { realTimeInventory: RealTimeInventoryModel; id: string, isRealTimeInventoryLoaded: boolean },
    ) => {
        const productInfoList = draft.productInfoListStatusById[action.id];
        if (!productInfoList) {
            throw new Error(`There was no productInfoList found for the id ${action.id}`);
        }

        productInfoList.isRealTimeInventoryLoaded = true;
    },
    "Components/CustomProductInfoLists/FailedLoadRealTimeInventory": (
        draft: Draft<CustomProductInfoListStatusState>,
        action: { id: string, isRealTimeInventoryLoaded: boolean },
    ) => {
        const productInfoList = draft.productInfoListStatusById[action.id];
        if (!productInfoList) {
            throw new Error(`There was no productInfoList found for the id ${action.id}`);
        }
        productInfoList.isRealTimeInventoryLoaded = true;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);